import React, {useState} from "react";
import PaymentTypePicker from "../Settings/PaymentTypes/PaymentTypePicker";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";

export default function ApprovalRow({part, index, nominalCodes, paymentTypes, paymentObjects, codeObjects, onSave, trackingOptions, trackingOptionObjects}){
    const [editable, setEditable] = useState(false);
    const [partState, setPartState] = useState(part);

    const handleSave = (e) => {
        setEditable(false);
        onSave(e, partState);
    }

    const onChange = (e, isEvent=true) => {
        if(isEvent){
            e.stopPropagation();
        }
        let newPart = {...partState};
        newPart[e.target.name] = e.target.value;
        setPartState(newPart);
    };

    const onNominalChange = e => {
        e.stopPropagation();
        const toUpdate = {
            target: {
                name: e.target.name,
                value: codeObjects[e.target.value]
            }
        };
        onChange(toUpdate, false);
    }

    const onTrackingOptionChange = e => {
        e.stopPropagation();
        const toUpdate = {
            target: {
                name: e.target.name,
                value: trackingOptionObjects[e.target.value]
            }
        };
        onChange(toUpdate, false);
    }

    const onPaymentTypeChange = e => {
        e.stopPropagation();
        const toUpdate = {
            target: {
                name: e.target.name,
                value: paymentObjects[e.target.value]
            }
        };
        onChange(toUpdate, false);
    }

    return (
        <tr key={partState.id}>
            <td>{partState.name}</td>
            <td>{partState.cost}</td>
            {useEditableTableDateCell({
                propName:"date_ordered",
                value: partState.date_ordered,
                onChange,
                onSave: handleSave,
                editable,
                setEditable,
                disabled: false,
                inlineEdit: true
            })}
            <td>
                <PaymentTypePicker
                    value={partState.payment_type}
                    options={paymentTypes}
                    onSave={handleSave}
                    onChange={onPaymentTypeChange}
                    editable={editable}
                    setEditable={setEditable}
                    blank={true}
                    disabled={!editable}
                />
            </td>
            <td>
                <NominalCodePicker
                    name={"supplier_nominal_code"}
                    value={partState.supplier_nominal_code}
                    onSave={handleSave}
                    onChange={onNominalChange}
                    options={nominalCodes}
                    blank={true}
                    inlineEdit={true}
                    disabled={!editable}
                    editable={editable}
                    setEditable={setEditable}
                />
            </td>
            {useEditableTableTextCell({
                propName: "part_invoice_number",
                value: partState.part_invoice_number,
                onSave: handleSave,
                onChange,
                editable,
                setEditable,
                inlineEdit: true
            })}
            <td onClick={e => e.stopPropagation()}>
              <TrackingOptionsPicker
                name={"supplier_tracking_option"}
                value={partState.supplier_tracking_option}
                options={trackingOptions}
                onSave={handleSave}
                onChange={onTrackingOptionChange}
                editable={editable}
                setEditable={setEditable}
                blank={true}
                inlineEdit={true}
                disabled={!editable}
              />
            </td>
            {useEditableTableDateCell({
                propName: "invoice_date",
                value: partState.invoice_date,
                onSave: handleSave,
                onChange,
                editable,
                setEditable,
                inlineEdit: true
            })}
        </tr>
    )


}